import { c as _c } from "react/compiler-runtime";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { IdentityRegisterFormInterface } from "@/app/components/auth/Forms/IdentityRegisterForm/identityRegisterForm.interface";
import { DirectionRightIcon } from "@/app/components/UI/Icons";
import IInput from "@/app/components/Common/Input";
import registerContent from "@/app/components/auth/registerContent";
import Button from "@/app/components/UI/Button";
import JalaliDatePicker from "@/app/components/Common/JalaliDatePicker";
import removeEmptyKeys from "@/app/utils/removeEmptyKeys";
import { p2e } from "@/app/utils/replaceNumber";
import cn from "@/app/utils/cn";
import { useRouter } from "@/app/hooks/useRouter";
import { useTranslations } from "next-intl";
import { localeDirClient } from "@/app/utils/locale";
import { sendGTMEvent } from "@/app/utils/analytics";
import useUpdateJwt from "@/app/services/updateJwt.service";
import { getJalaliDateYearsAgo, isValidJalaliDate, jalaliToGregorianDate } from "@/app/utils/jalaliDate";
export default function IdentityRegisterForm(props) {
  const $ = _c(121);
  const [nid, setNid] = useState("");
  const [birthDate, setBirthDate] = useState(_temp);
  const [invitationCode, setInvitationCode] = useState(props.referralCode ? props.referralCode : "");
  const [discount_code] = useState("");
  const [nidError, setNidError] = useState(false);
  const [, setFormError] = useState("");
  const [invitationCodeError, setInvitationCodeError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const submitPendingRef = useRef(false);
  const {
    updateJwt
  } = useUpdateJwt();
  const t = useTranslations();
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] !== props.referralCode) {
    t0 = () => {
      if (props.referralCode) {
        setInvitationCode(props.referralCode);
      }
    };
    t1 = [props.referralCode];
    $[0] = props.referralCode;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== router) {
    t2 = () => {
      const afterLogin = localStorage.getItem("redirectAfterLogin");
      const afterPath = localStorage.getItem("redirectPath");
      let target;
      if (afterLogin) {
        target = afterLogin;
        localStorage.removeItem("redirectAfterLogin");
      } else {
        if (afterPath) {
          target = afterPath;
        } else {
          target = "/";
        }
      }
      router.push(target);
      localStorage.removeItem("redirectPath");
      localStorage.removeItem("referralCode");
    };
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const navigate = t2;
  let t3;
  if ($[5] !== navigate || $[6] !== props.isSuccess || $[7] !== updateJwt) {
    t3 = () => {
      if (!props.isSuccess) {
        return;
      }
      (async () => {
        ;
        try {
          await updateJwt();
          navigate();
        } catch (t4) {
          const err = t4;
          console.error(err);
        }
      })();
    };
    $[5] = navigate;
    $[6] = props.isSuccess;
    $[7] = updateJwt;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props.isSuccess) {
    t4 = [props.isSuccess];
    $[9] = props.isSuccess;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[11] !== props.isError) {
    t5 = () => {
      if (props.isError) {
        submitPendingRef.current = false;
      }
    };
    t6 = [props.isError];
    $[11] = props.isError;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] !== birthDate || $[15] !== invitationCodeError || $[16] !== navigate || $[17] !== nid || $[18] !== nidError || $[19] !== props.error?.response?.data?.number || $[20] !== props.isError || $[21] !== props.isPending || $[22] !== props.isSuccess) {
    t7 = () => {
      const hasValidBirthDate = isValidJalaliDate(birthDate);
      if (props.isSuccess) {
        setDisabled(true);
        return;
      }
      if (nid && hasValidBirthDate && !nidError && !invitationCodeError && !props.isPending) {
        setDisabled(false);
      }
      if (props.isError) {
        if (props.error?.response?.data?.number === 2242210042) {
          setDisabled(true);
          navigate();
        } else {
          if (props.error?.response?.data?.number === 2242210028) {
            setDisabled(false);
          }
        }
      }
    };
    $[14] = birthDate;
    $[15] = invitationCodeError;
    $[16] = navigate;
    $[17] = nid;
    $[18] = nidError;
    $[19] = props.error?.response?.data?.number;
    $[20] = props.isError;
    $[21] = props.isPending;
    $[22] = props.isSuccess;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== birthDate || $[25] !== invitationCodeError || $[26] !== nid || $[27] !== nidError || $[28] !== props.error || $[29] !== props.isError || $[30] !== props.isPending || $[31] !== props.isSuccess) {
    t8 = [nid, birthDate, nidError, invitationCodeError, props.isPending, props.isError, props.error, props.isSuccess];
    $[24] = birthDate;
    $[25] = invitationCodeError;
    $[26] = nid;
    $[27] = nidError;
    $[28] = props.error;
    $[29] = props.isError;
    $[30] = props.isPending;
    $[31] = props.isSuccess;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  useEffect(t7, t8);
  let t9;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = value => {
      if (value.length !== 10 || /\s/.test(value)) {
        setNidError(true);
      } else {
        setNidError(false);
      }
    };
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  const validateNationalId = t9;
  let t10;
  if ($[34] !== props) {
    t10 = function submitKyc(nid_0, birthDate_0, referral_code, discount_code_0) {
      let dataToSend = {
        national_id: nid_0,
        birth_date: jalaliToGregorianDate(birthDate_0),
        referral_code: referral_code || null,
        discount_code: discount_code_0 || null,
        mobile: props.mobile,
        tracking_id: props.trackingId
      };
      dataToSend = removeEmptyKeys(dataToSend);
      props.onSubmit(dataToSend);
    };
    $[34] = props;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  const submitKyc = t10;
  let t11;
  if ($[36] !== birthDate || $[37] !== disabled || $[38] !== discount_code || $[39] !== invitationCode || $[40] !== nid || $[41] !== props.isPending || $[42] !== props.isSuccess || $[43] !== submitKyc) {
    t11 = function sendIdentityFunc(e) {
      e.preventDefault();
      if (disabled || props.isPending || props.isSuccess || submitPendingRef.current || !isValidJalaliDate(birthDate)) {
        return;
      }
      submitPendingRef.current = true;
      setDisabled(true);
      setFormError("");
      submitKyc(nid, birthDate, invitationCode, discount_code);
      sendGTMEvent({
        event: "Register",
        page: "auth",
        action: "trigger"
      });
    };
    $[36] = birthDate;
    $[37] = disabled;
    $[38] = discount_code;
    $[39] = invitationCode;
    $[40] = nid;
    $[41] = props.isPending;
    $[42] = props.isSuccess;
    $[43] = submitKyc;
    $[44] = t11;
  } else {
    t11 = $[44];
  }
  const sendIdentityFunc = t11;
  let t12;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className={cn(localeDirClient() === "ltr" ? "rotate-180" : "")}><DirectionRightIcon className="w-6 h-6" /></div>;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== props.backFunc) {
    t13 = <div className="md:hidden"><div className="mt-20 cursor-pointer" onClick={props.backFunc}>{t12}</div></div>;
    $[46] = props.backFunc;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== t) {
    t14 = t("auth.IDENTITY");
    $[48] = t;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== t14) {
    t15 = <h1 className="text-base md:text-2xl font-bold">{t14}</h1>;
    $[50] = t14;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  let t16;
  if ($[52] !== t) {
    t16 = t("auth.IDENTITY_TEXT");
    $[52] = t;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  let t17;
  if ($[54] !== t16) {
    t17 = <p className="text-charcoal-600 text-sm mt-4">{t16}</p>;
    $[54] = t16;
    $[55] = t17;
  } else {
    t17 = $[55];
  }
  let t18;
  if ($[56] !== t15 || $[57] !== t17) {
    t18 = <div className="mt-6 mb-8">{t15}{t17}</div>;
    $[56] = t15;
    $[57] = t17;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  let t19;
  if ($[59] !== t) {
    t19 = t(registerContent.Nid);
    $[59] = t;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  let t20;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = e_0 => {
      const cleanedValue = p2e(e_0.target.value.replace(/\s/g, ""));
      setNid(cleanedValue);
      validateNationalId(cleanedValue);
    };
    $[61] = t20;
  } else {
    t20 = $[61];
  }
  let t21;
  if ($[62] !== nid || $[63] !== nidError || $[64] !== t19) {
    t21 = <div className="mt-5 relative"><IInput inputId="NidInput" label={t19} type="text" value={nid} onChange={t20} hasError={nidError} style="secondaryOutline" /></div>;
    $[62] = nid;
    $[63] = nidError;
    $[64] = t19;
    $[65] = t21;
  } else {
    t21 = $[65];
  }
  let t22;
  if ($[66] !== t) {
    t22 = t("auth.BIRTH_DATE");
    $[66] = t;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  let t23;
  if ($[68] !== t22) {
    t23 = <label className="font-semibold text-charcoal-900 text-sm">{t22}</label>;
    $[68] = t22;
    $[69] = t23;
  } else {
    t23 = $[69];
  }
  let t24;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = value_0 => setBirthDate(value_0);
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== t) {
    t25 = t("auth.BIRTH_DATE");
    $[71] = t;
    $[72] = t25;
  } else {
    t25 = $[72];
  }
  let t26;
  if ($[73] !== birthDate || $[74] !== t25) {
    t26 = <JalaliDatePicker value={birthDate} onChange={t24} placeholder={t25} inputClassName="h-12 w-full border border-charcoal-300 text-sm font-bold p-2 mt-2 rounded-xl" />;
    $[73] = birthDate;
    $[74] = t25;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  let t27;
  if ($[76] !== birthDate) {
    t27 = birthDate && !isValidJalaliDate(birthDate) && <div className="text-red-500 text-sm mt-1">تاریخ تولد معتبر نیست.</div>;
    $[76] = birthDate;
    $[77] = t27;
  } else {
    t27 = $[77];
  }
  let t28;
  if ($[78] !== t23 || $[79] !== t26 || $[80] !== t27) {
    t28 = <div className="mt-5 relative">{t23}{t26}{t27}</div>;
    $[78] = t23;
    $[79] = t26;
    $[80] = t27;
    $[81] = t28;
  } else {
    t28 = $[81];
  }
  let t29;
  if ($[82] !== t) {
    t29 = t(registerContent.invitationCode);
    $[82] = t;
    $[83] = t29;
  } else {
    t29 = $[83];
  }
  const t30 = props.referralCode || invitationCode;
  let t31;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = e_1 => {
      const value_1 = e_1.target.value.slice(0, 6);
      setInvitationCode(value_1);
      setInvitationCodeError(value_1.length > 0 && value_1.length < 6);
    };
    $[84] = t31;
  } else {
    t31 = $[84];
  }
  const t32 = !invitationCodeError ? "secondaryOutline" : "secondaryOutlineError";
  const t33 = !!props.referralCode;
  let t34;
  if ($[85] !== t29 || $[86] !== t30 || $[87] !== t32 || $[88] !== t33) {
    t34 = <IInput inputId="InvitationInput" label={t29} type="text" value={t30} onChange={t31} style={t32} customFieldClassName="disabled:cursor-not-allowed disabled:text-charcoal-600" disabled={t33} maxLength={6} />;
    $[85] = t29;
    $[86] = t30;
    $[87] = t32;
    $[88] = t33;
    $[89] = t34;
  } else {
    t34 = $[89];
  }
  let t35;
  if ($[90] !== invitationCodeError) {
    t35 = invitationCodeError && <div className="text-red-500 text-sm absolute">کد دعوت باید ۶ رقم باشد.</div>;
    $[90] = invitationCodeError;
    $[91] = t35;
  } else {
    t35 = $[91];
  }
  let t36;
  if ($[92] !== t34 || $[93] !== t35) {
    t36 = <div className="mt-5 relative">{t34}{t35}</div>;
    $[92] = t34;
    $[93] = t35;
    $[94] = t36;
  } else {
    t36 = $[94];
  }
  let t37;
  if ($[95] !== birthDate || $[96] !== disabled || $[97] !== props.isPending || $[98] !== props.isSuccess) {
    t37 = disabled || props.isPending || props.isSuccess || !isValidJalaliDate(birthDate);
    $[95] = birthDate;
    $[96] = disabled;
    $[97] = props.isPending;
    $[98] = props.isSuccess;
    $[99] = t37;
  } else {
    t37 = $[99];
  }
  let t38;
  if ($[100] !== sendIdentityFunc) {
    t38 = e_2 => sendIdentityFunc(e_2);
    $[100] = sendIdentityFunc;
    $[101] = t38;
  } else {
    t38 = $[101];
  }
  let t39;
  if ($[102] !== t) {
    t39 = t(registerContent.step3Button);
    $[102] = t;
    $[103] = t39;
  } else {
    t39 = $[103];
  }
  let t40;
  if ($[104] !== t39) {
    t40 = <span className="text-center">{t39} </span>;
    $[104] = t39;
    $[105] = t40;
  } else {
    t40 = $[105];
  }
  let t41;
  if ($[106] !== t37 || $[107] !== t38 || $[108] !== t40) {
    t41 = <div className="mt-7 w-full"><Button fullWidth={true} disabled={t37} onClick={t38}>{t40}</Button></div>;
    $[106] = t37;
    $[107] = t38;
    $[108] = t40;
    $[109] = t41;
  } else {
    t41 = $[109];
  }
  let t42;
  if ($[110] !== t21 || $[111] !== t28 || $[112] !== t36 || $[113] !== t41) {
    t42 = <form>{t21}{t28}{t36}{t41}</form>;
    $[110] = t21;
    $[111] = t28;
    $[112] = t36;
    $[113] = t41;
    $[114] = t42;
  } else {
    t42 = $[114];
  }
  let t43;
  if ($[115] !== t18 || $[116] !== t42) {
    t43 = <div className="relative">{t18}{t42}</div>;
    $[115] = t18;
    $[116] = t42;
    $[117] = t43;
  } else {
    t43 = $[117];
  }
  let t44;
  if ($[118] !== t13 || $[119] !== t43) {
    t44 = <>{t13}{t43}</>;
    $[118] = t13;
    $[119] = t43;
    $[120] = t44;
  } else {
    t44 = $[120];
  }
  return t44;
}
function _temp() {
  return getJalaliDateYearsAgo(18);
}